import type { ResolvedLinkProps } from "types/storyblok.d";
import type { LanguageCode } from "config/languages";
import { getSlugWithoutLocale } from "utils/getSlugWithoutLocale";
import { isDefaultLanguage } from "utils/isDefaultLanguage";

const getUrlFromLink = (link: ResolvedLinkProps, language?: LanguageCode): string => {
  if (!link) return undefined;

  const localeFromSlug = link.story?.full_slug.split("/")[0] as LanguageCode;
  const localeFromUrl = link.url?.split("/")[1] as LanguageCode;

  const isDefault = isDefaultLanguage(localeFromSlug) || isDefaultLanguage(localeFromUrl);

  let storyLink;
  let storyUrl;

  if (isDefault) {
    const storySlug = getSlugWithoutLocale(link.story?.full_slug);

    storyLink = storySlug ? `/${language}/${storySlug}` : "";
    storyUrl = link.linktype === "story" ? `/${language}/${getSlugWithoutLocale(link.url)}` : link.url;

    return storyLink || storyUrl;
  }

  const storyFullSlug = link.story?.full_slug;
  storyLink = storyFullSlug ? `/${storyFullSlug}` : "";
  storyUrl = link.url;

  return storyLink || storyUrl;
};

export default getUrlFromLink;
